<template>
  <editable-box
    ref="editableBox"
    :mode="mode"
    :includeBtns="['drag', 'setup', 'delete', 'add']"
    @onAdd="handelAdd"
    @onDelete="handelDelete"
    @onSetup="hanldeSetup"
  >
    <div class="info-box">
      <div class="title" v-if="!data.isHideTitle">
        <text-box
          type="editor"
          position="rightTop"
          :mode="mode"
          :image-style="{ height: '22px' }"
          :value="data.title"
          @onChange="handleNameChange"
        >
          {{ data.title || "名称" }}
        </text-box>
      </div>
      <div class="content" v-if="!data.isHideContent">
        <text-box
          type="editor"
          position="rightTop"
          :mode="mode"
          :image-style="{ height: '22px' }"
          :value="data.content"
          @onChange="handleContentChange"
        >
          {{ data.content || "内容" }}
        </text-box>
      </div>
      <!-- 设置 -->
      <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="data" @onChange="handleItemSetup"></setup-panel>
    </div>
  </editable-box>
</template>

<script>
// components
import EditableBox from "../../../../components/EditableBox/index.jsx";
import TextBox from "../../../../components/TextBox";
import SetupPanel from "./SetupPanel";

export default {
  name: "InfoBox",
  components: {
    EditableBox,
    TextBox,
    SetupPanel
  },
  props: {
    mode: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    isEditorValue() {
      return (
        this.data &&
        typeof this.data.content !== "string" &&
        this.data.content.type &&
        this.data.content.type === "simpleEditor"
      );
    }
  },

  mounted() {},

  methods: {
    handelAdd() {
      this.$emit("onAdd");
    },
    handelDelete() {
      this.$emit("onDelete");
    },
    hanldeSetup() {
      this.$refs.setupPanel.open();
    },
    handleItemSetup(data) {
      this.$emit("onChange", data);
    },
    handleNameChange(name) {
      this.$emit("onChange", {
        ...this.data,
        title: name
      });
    },
    handleContentChange(content) {
      this.$emit("onChange", {
        ...this.data,
        content: content
      });
    }
  }
};
</script>

<style lang="less" scoped>
.info-box {
  display: flex;
  flex-direction: column;
  min-width: 52px;
  min-height: 25px;
  gap: 10px;
  background: rgba(122, 147, 172, 0.12);
  border-radius: 8px;
  padding: 6px;
  .title {
    width: 100%;
    height: 22px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #373737;
    line-height: 22px;
  }
  .content {
    min-width: 75px;
    font-size: 18px;
    font-weight: bold;
    color: #212121;
    line-height: 25px;
    text-align: center;
  }
}
</style>
